import { render, staticRenderFns } from "./PeersRatings.vue?vue&type=template&id=6ce98aa0&scoped=true"
import script from "./PeersRatings.vue?vue&type=script&lang=js"
export * from "./PeersRatings.vue?vue&type=script&lang=js"
import style0 from "./PeersRatings.vue?vue&type=style&index=0&id=6ce98aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce98aa0",
  null
  
)

export default component.exports